import styled from 'styled-components';
import {Typography} from '../typography/typography';
import {getColorFromTheme} from '../../ui-utils';

export const InFormButton = styled.span`
  ${Typography};

  font-size: 14px;
  font-weight: 500;
  line-height: 1.7;
  color: ${getColorFromTheme('textBody')};
  background-color: ${getColorFromTheme('borderLight')};
  padding: 4px 8px;
  border-radius: 8px;
  outline: none;
`;
